const theme = {
  black: '#222',
  twitter: '#1DA1F2',
  green: '#678A5F',
  gray: '#999',
  serif: `'Palatino Linotype', 'Book Antiqua', Palatino, serif`,
  sansSerif: `-apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen,
    Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, sans-serif`,
  textShadow: `0px 0px 5px rgba(0, 0, 0, 0.5)`,
  comment: '#777',
  quote: '#6a737c',
  primary: '',
};

theme.primary = theme.green;

export default theme;

export type Theme = typeof theme;
